<script lang="ts">
  // Thumbnail of a cosmetic for the box craft/wardrobe grids. Outfits/costumes render ON the player's
  // avatar (AvatarThumb, a cheap 2D composite, so a whole grid is fine); duel disks and sleeves
  // render solo (they read better that way). One cheap canvas/img per item, no Pixi avatar per tile.
  import { findDuelDisk, type CosmeticKind, type ChibiLook } from "@ygoevo/world-protocol";
  import AvatarThumb from "./AvatarThumb.svelte";
  import DuelDiskSwatch from "./duel/DuelDiskSwatch.svelte";
  import SleeveSwatch from "./duel/SleeveSwatch.svelte";

  let { kind, sku, look }: { kind: CosmeticKind; sku: string; look: ChibiLook } = $props();

  const disk = $derived(kind === "dueldisk" ? findDuelDisk(sku) : null);
</script>

{#if kind === "outfit"}
  <AvatarThumb {look} {sku} />
{:else if disk}
  <DuelDiskSwatch slot={disk.def.slot} variant={disk.def.variant} color={disk.c.color} gender={look.gender} />
{:else if kind === "sleeve"}
  <div class="grid size-full place-items-center"><div class="aspect-[59/86] h-full max-h-full overflow-hidden chamfer" style="--c:4px"><SleeveSwatch id={sku} /></div></div>
{/if}
